import * as z from "zod";
import { gql } from "graphql-request";
import { SysSchema, SysFragment } from "../sys";
import { ImageSchema, ImageFragment } from "../image";
import { UnifiedButtonSchema, UnifiedButtonFragment } from "../unifiedButton";

export const MilestoneSchema = z.object({
  id: z.string(),
  value: z.number().nullable().optional(),
  label: z.string().nullable().optional(),
  image: z
    .object({
      id: z.string(),
      title: z.string(),
      width: z.number(),
      height: z.number(),
      url: z.string(),
    })
    .nullable()
    .optional(),
  voucherId: z.string().nullable().optional(),
  eventId: z
    .union([z.string(), z.array(z.string())])
    .nullable()
    .optional(),
});

export const MilestonesArraySchema = z.array(MilestoneSchema).nullable();

export const MilestonesArray = MilestonesArraySchema;
export type MilestonesArray = z.infer<typeof MilestonesArraySchema>;

export const CarouselEventProgressTrackerEntrySchema = z.object({
  __typename: z.literal("CarouselEventProgressTrackerEntry"),
  sys: SysSchema,
  entryTitle: z.string().nullable(),
  maxProgress: z.number().nullable(),

  ctaButtonsCollection: z
    .object({
      items: z.array(UnifiedButtonSchema).nullish(),
    })
    .nullish(),
  progressValue: z.number().nullable(),
  barColor: z.string().nullable(),

  showEqualDistance: z.boolean().nullable(),

  carouselImage: ImageSchema.nullable(),
  carouselImageEn: ImageSchema.nullable(),

  milestones: MilestonesArraySchema,
});

export type CarouselEventProgressTrackerEntry = z.infer<
  typeof CarouselEventProgressTrackerEntrySchema
>;

export const CarouselEventProgressTrackerEntryFragment = gql`
  fragment CarouselEventProgressTrackerEntryFragment on CarouselEventProgressTrackerEntry {
    __typename
    sys {
      ...SysFragment
    }

    ctaButtonsCollection {
      items {
        __typename
        ... on UnifiedButton {
          ...UnifiedButtonFragment
        }
      }
    }

    entryTitle
    maxProgress
    progressValue
    barColor
    showEqualDistance

    carouselImage {
      ...ImageFragment
    }
    carouselImageEn: carouselImage(locale: "en") {
      ...ImageFragment
    }

    milestones
  }

  ${SysFragment}
  ${ImageFragment}
  ${UnifiedButtonFragment}
`;
